import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
export interface TrendIndicatorProps {
  value: number;
  label?: string;
  direction: 'up' | 'down';
  inverse?: boolean;
}
export function TrendIndicator({
  value,
  label = '',
  direction,
  inverse = false
}: TrendIndicatorProps) {
  // Determine if this is a positive trend
  const isPositive = inverse ? direction === 'down' : direction === 'up';
  const colorClass = isPositive ? 'text-[#10B981]' : 'text-[#EF4444]';
  const Icon = direction === 'up' ? TrendingUp : TrendingDown;
  return <div className={`flex items-center gap-1 text-xs ${colorClass}`} data-id="element-6333" data-mp="191fv17kdhi4h">
      <Icon className="w-3 h-3" data-id="element-6334" data-mp="1e1ttbxw69dpb" />
      <span className="font-medium" data-id="element-6335" data-mp="1e0irw4q78i1d">{value}%</span>
      {label && <span className="text-[#64748B]" data-id="element-6336" data-mp="1iu3q9xvpfe13">{label}</span>}
    </div>;
}